import { ModelEntityType } from '@upright/common/model/input/types';
import { ApiVariantKey } from '@upright/common/model/output/scores/model-entity-data/api-types';
import { useGetVariantKey } from '@upright/ui/api/common/hooks';
import { useGetModelEntityScoreData } from '@upright/ui/api/model/output/scores/model-entity-data/use-get-model-entity-score-data';

export function useCompanyScores(
  companyId: string | undefined,
  {
    options,
    overrides,
  }: {
    options?: ApiVariantKey;
    overrides?: { release?: string };
  } = {},
) {
  const defaultVariantKey = useGetVariantKey();
  const companyOptions = options ?? defaultVariantKey;

  const modelEntityReference = companyId ? { id: companyId, type: ModelEntityType.COMPANY } : undefined;

  return useGetModelEntityScoreData({
    modelEntityReference,
    options: companyOptions,
    overrides: {
      releaseOrVersion: overrides?.release,
    },
  });
}
